import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Film, Users, Sparkles, Heart } from 'lucide-react';

const Section = ({ children, className = '' }) => (
  <section className={`relative z-10 max-w-3xl mx-auto px-6 ${className}`}>{children}</section>
);

const About = () => (
  <div className="min-h-screen relative overflow-hidden">
    <div className="absolute inset-0">
      <div className="absolute -top-40 -left-40 w-[560px] h-[560px] rounded-full bg-[#E50914]/10 blur-[160px]" />
      <div className="absolute -bottom-32 -right-20 w-[520px] h-[520px] rounded-full bg-amber-500/5 blur-[160px]" />
    </div>

    <header className="relative z-10 max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-3 text-white/70 hover:text-white"><ArrowLeft size={18} /> Back</Link>
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-[#E50914] flex items-center justify-center">
          <span className="font-display text-xl text-white leading-none">B</span>
        </div>
        <div className="font-display text-xl tracking-wider text-white">BLUNT TV</div>
      </div>
    </header>

    <Section className="py-16 text-center">
      <span className="text-[11px] tracking-widest uppercase text-white/50">About</span>
      <h1 className="font-display text-5xl md:text-7xl text-white mt-3">Stream boldly. Watch blunt.</h1>
      <p className="mt-5 text-white/70 text-lg leading-relaxed">
        BLUNT TV is a hybrid platform: part <span className="text-white font-semibold">independent studio</span>, part <span className="text-white font-semibold">discovery app</span>.
        Subscribers get full HD streaming of exclusive <span className="text-white font-semibold">BLUNT Originals</span>
        — indie films and series you won’t find anywhere else — plus ad-free trailers and personalized recommendations for 10,000+ other movies and shows.
      </p>
    </Section>

    <Section className="pb-12">
      <div className="grid md:grid-cols-3 gap-4">
        {[
          { icon: Film, title: 'Independent first', desc: 'We partner directly with indie filmmakers, documentarians, and creators so their work reaches a real audience.' },
          { icon: Users, title: 'Built for the whole house', desc: 'Up to 4 profiles including Kids mode with automatic genre filtering.' },
          { icon: Sparkles, title: 'Everywhere you watch', desc: 'Web today, Roku channel coming soon, Chromecast-ready now. Same account, same list, every device.' },
        ].map(({ icon: Icon, title, desc }) => (
          <div key={title} className="p-6 rounded-2xl bg-white/5 border border-white/10">
            <div className="w-10 h-10 rounded-xl bg-[#E50914]/15 text-[#E50914] flex items-center justify-center mb-3"><Icon size={18} /></div>
            <div className="text-white font-semibold">{title}</div>
            <div className="text-white/60 text-sm mt-1">{desc}</div>
          </div>
        ))}
      </div>
    </Section>

    <Section className="pb-16">
      <div className="p-8 rounded-2xl bg-white/5 border border-white/10">
        <div className="flex items-center gap-3 mb-4">
          <Heart size={18} className="text-[#E50914]" />
          <h2 className="text-2xl font-semibold text-white">Our mission</h2>
        </div>
        <p className="text-white/75 leading-relaxed">
          Traditional streaming giants prioritize algorithmic noise and recycled franchises. BLUNT TV exists to flip that —
          we surface fresh voices, pay creators fairly, and keep the viewing experience simple, fast, and ad-free.
          Whether you’re here for a Friday-night blockbuster or a documentary from a first-time director, you’re in the right place.
        </p>
        <div className="mt-5 text-sm text-white/50">
          BLUNT TV is an independent service. All film and TV metadata is provided by TMDB. Product names and cover art belong to their respective owners.
        </div>
      </div>
    </Section>

    <footer className="relative z-10 py-8 text-center text-white/40 text-sm">
      © {new Date().getFullYear()} BLUNT TV • <Link className="hover:text-white" to="/contact">Contact</Link> • <Link className="hover:text-white" to="/terms">Terms</Link> • <Link className="hover:text-white" to="/privacy">Privacy</Link>
    </footer>
  </div>
);

export default About;
